import Itinerary from './Itinerary';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  tab: {
    color: grey[300],
    opacity: '75%',
    '&.Mui-selected': {
      opacity: '100%',
      color: '#80CBC4',
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`itineary-tabpanel-${index}`}
      aria-labelledby={`itineary-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `itineary-tab-${index}`,
    'aria-controls': `itineary-tabpanel-${index}`,
  };
}

export default function Itineraries({ itineraries, setValue, value }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { classes } = useStyles();

  //   return itineraries.map(itinerary => {
  return (
    <>
      <Box
        // sx={{ borderBottom: 1, borderColor: 'divider' }}
        className="-tw-mt-4"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="itineary tabs"
          centered
          variant="fullWidth"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#80CBC4',
            },
          }}
        >
          {itineraries.map(itinerary => {
            return (
              <Tab
                key={itinerary.theme}
                label={itinerary.theme}
                {...a11yProps(0)}
                style={{ minWidth: '25%' }}
                className={classes.tab}
              />
            );
          })}
        </Tabs>
      </Box>
      {itineraries.map((itinerary, i) => {
        return (
          <TabPanel value={value} index={i} key={itinerary.title}>
            <Itinerary itinerary={itinerary} />
          </TabPanel>
        );
      })}
    </>
  );
}
